import PropTypes from 'prop-types';

import {
  DisabledDefaultProps,
  DisabledPropTypes,
} from '@/common/proptypes/Base/Disabled.proptypes';
import {
  IsLoadingDefaultProps,
  IsLoadingPropTypes,
} from '@/common/proptypes/Base/IsLoading.proptypes';

export const CartDefaultProps = {
  ...DisabledDefaultProps,
  ...IsLoadingDefaultProps,
  cart: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.PropTypes.shape({})),
  }),
  refetchCart: () => null,
};

export const CartPropTypes = {
  ...DisabledPropTypes,
  ...IsLoadingPropTypes,
  cart: PropTypes.PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.PropTypes.shape({})),
    name: PropTypes.string,
  }),
  refetchCart: PropTypes.func,
};
